<template>
  <div class="group-add">
    <van-form
      ref="form"
      :readonly="type === 'check'"
    >
      <van-field
        readonly
        clickable
        name="picker"
        :value="form.channel_name"
        label="机构选择"
        placeholder="点击选择机构"
        @click="openPicker('institutionPicker')"
        :rules="[{ required: true, message: '请选择机构' }]"
      />
      <van-popup
        v-model="institutionPicker"
        position="bottom"
      >
        <div class="booking-home-search">
          <div class="booking-home-search-header">
            <div @click="institutionPicker = false">
              取消
            </div>
            <div
              class="booking-submit"
              @click="onCompanyConfirm"
            >
              完成
            </div>
          </div>
          <div class="booking-division" />

          <form action="/">
            <van-search
              v-model="searchForm.company"
              placeholder="请输入搜索关键词"
              show-action
              @search="channels"
            >
              <template #action>
                <div @click="channels(searchForm.company)">搜索</div>
              </template>
            </van-search>
          </form>
          <div class="booking-division" />

          <div class="booking-home-search-list">
            <div
              v-for="item in channelColumns"
              :key="item.channel_id"
              class="booking-home-search-item"
              :class="{
                'booking-home-search-item-current': item.select
              }"
              @click="onCompanyChange(item)"
            >
              {{ item.channel_name }}
            </div>
          </div>
        </div>
      </van-popup>

      <van-field
        readonly
        clickable
        name="picker"
        :value="form.typeName"
        label="包场类型"
        placeholder="点击选择包场类型"
        @click="openPicker('venueTypePicker')"
        :rules="[{ required: true, message: '请选择包场类型' }]"
      />
      <van-popup
        v-model="venueTypePicker"
        position="bottom"
      >
        <van-picker
          ref="venueTypePickerRef"
          show-toolbar
          :columns="venueTypeColumns"
          @cancel="venueTypePicker = false"
          @confirm="venueTypeConfirm"
        />
      </van-popup>
      <van-field
        readonly
        clickable
        name="calendar"
        :value="form.booking_date"
        label="包场日期"
        placeholder="点击选择日期"
        @click="openPicker('showCalendar')"
        :rules="[{ required: true, message: '请选择日期' }]"
      />
      <van-calendar
        :formatter="formatter"
        :min-date="calendarInfor.minDate"
        :max-date="calendarInfor.maxDate"
        v-model="showCalendar"
        @confirm="calendarConfirm"
      />
      <van-field
        v-model="form.number"
        name="包场人数"
        label="包场人数"
        placeholder="包场人数"
        type="digit"
        :rules="[{ required: true, message: '请填写包场人数' }]"
      />
      <van-field
        v-model="form.price"
        name="包场金额"
        label="包场金额"
        placeholder="包场金额"
        ype="number"
        :rules="[{ required: true, message: '请填写包场金额' }]"
      />
      <van-field
        v-model="form.leader_name"
        name="团长姓名"
        label="团长姓名"
        placeholder="团长姓名"
        :rules="[{ required: true, message: '请填写团长姓名' }]"
      />
      <van-field
        v-model="form.leader_mobile"
        type="tel"
        label="团长手机号"
        placeholder="团长手机号"
        :rules="[
            { required: true, message: '请填写团长手机号' },
        { pattern: /^1(3|4|5|6|7|8|9)\d{9}$/, message: '请输入正确手机号' }
        ]"
      />
      <van-field
        v-if="type === 'check' && form.audit_status !== 0"
        :value="form.audit_status === 1 ? '已通过' : '未通过'"
        type="tel"
        label="状态"
        placeholder="团长手机号"
      />

      <div
        class="group-add-btn"
        v-else-if="type === 'add'"
      >
        <el-button
          type="primary"
          @click="bookingEdit"
          :loading="loading"
        >提交</el-button>
      </div>
      <div
        class="group-add-btn"
        v-else
      >
        <el-button
          type="primary"
          @click="checkSub(1)"
          :loading="loading"
        >通过</el-button>
        <el-button
          type="primary"
          @click="checkSub(2)"
          :loading="loading"
        >不通过</el-button>
      </div>
    </van-form>
  </div>
</template>

<script>
import teamService from "@/apis/team";
import moment from "moment";
import enums from "@/views/booking/mixins/enums";
import { Toast } from "vant";

export default {
  mixins: [enums],

  data() {
    return {
      // add: 添加
      // check: 审核
      type: "add",
      venueTypePicker: false,
      institutionPicker: false,
      showCalendar: false,

      calendarInfor: {
        minDate: moment().add(30, "d").toDate(),
        maxDate: moment().add(45, "d").toDate(),
      },

      form: {},
      channelColumns: [],
      venueTypeColumns: [
        {
          text: "半包",
          id: 1,
        },
        {
          text: "全包",
          id: 2,
        },
      ],
      bookedDates: [],
      summitting: false,
      loading: false,
      searchForm: {},
      currentSelectCompany: {},
    };
  },
  created() {
    this.channels();
    this.getCalendar();
    if (this.$route.query.guid) {
      this.type = "check";
      this.bookingInfo();
    }
  },
  methods: {
    async bookingEdit() {
      const { form, currentUserInfo } = this;
      const validateResult = await this.$refs.form.validate();
      console.log(validateResult);
      const params = {
        submit_ding_id: currentUserInfo.user_id,
        ...form,
      };
      this.summitting = true;
      teamService
        .bookingEdit(params)
        .then((res) => {
          Toast("提交成功");
          this.summitting = false;
          console.log(res);
        })
        .catch(() => {
          this.summitting = false;
        });
    },
    checkSub(status) {
      const { currentUserInfo } = this;
      const params = {
        guid: this.$route.query.guid,
        audit_ding_id: currentUserInfo.user_id,
        audit_status: status,
        audit_reason: "",
      };
      this.summitting = true;
      teamService
        .bookingAudit(params)
        .then(() => {
          Toast("提交成功");
          this.summitting = false;
        })
        .catch(() => {
          this.summitting = false;
        });
    },
    bookingInfo() {
      const { venueTypeColumns } = this;
      const params = {
        guid: this.$route.query.guid,
      };
      teamService.bookingInfo(params).then((res) => {
        this.form = res;
        venueTypeColumns.some((item) => {
          if (item.id === res.type) {
            this.form.typeName = item.text;
            return true;
          }
        });
        console.log(res);
      });
    },
    channels(query = "") {
      const params = {
        query,
      };
      teamService.channels(params).then((res) => {
        this.channelColumns = res;
        console.log(res);
      });
    },
    getCalendar() {
      const params = {
        submit_ding_id: "",
      };
      teamService.calendar(params).then((res) => {
        console.log(res);
        res.forEach((item) => {
          this.bookedDates.push(item.booking_date);
        });
      });
    },
    venueTypeConfirm(item) {
      const { form } = this;
      form.type = item.id;
      form.typeName = item.text;
      this.venueTypePicker = false;
    },
    onInstitutionConfirm(item) {
      const { form } = this;
      form.channel_name = item.channel_name;
      form.channel_id = item.channel_id;
      this.institutionPicker = false;
    },
    onCompanyChange(company) {
      const { channelColumns } = this;
      this.currentSelectCompany = company;

      channelColumns.forEach((item) => {
        item.select = false;
      });
      company.select = true;
      this.channelColumns = [...channelColumns];
    },
    onCompanyConfirm() {
      const { currentSelectCompany, form } = this;
      if (!currentSelectCompany.channel_id) {
        Toast("请选择机构");
        return;
      }
      form.channel_name = currentSelectCompany.channel_name;
      form.channel_id = currentSelectCompany.channel_id;
      this.institutionPicker = false;
    },
    calendarConfirm(date) {
      const { form } = this;
      console.log(date);
      form.booking_date = moment(date).format("YYYY-MM-DD");
      this.showCalendar = false;
    },
    formatter(day) {
      const { bookedDates } = this;
      if (bookedDates.includes(moment(day.date).format("YYYY-MM-DD"))) {
        day.type = "disabled";
        // day.className = "van-calendar__day--disabled";
        // day.topInfo = "已预约";
      }
      return day;
    },
    openPicker(key) {
      if (this.type === "check") return;
      this[key] = true;
    },
    onSubmit() {
      console.log("submit");
    },
  },
};
</script>

<style scoped lang="scss">
.group-add {
  .el-button {
    width: 100%;
  }
}
.group-add-btn {
  display: flex;
  margin: 16px;
}
</style>